import Message from './Message.vue';

export default Message;



// WEBPACK FOOTER //
// ./src/pages/profile/views/settings/components/message/index.ts